import { FormGroup, ValidatorFn } from '@angular/forms';
import { getControl } from '@shared/helpers/form.helper';

export abstract class FormListeners {
    protected form: FormGroup;

    constructor(form: FormGroup) {
        this.form = form;
    }

    protected abstract setListeners(): void;

    protected setValidators(field: string, validators: ValidatorFn[], targetForm = this.form): void {
        const targetControl = getControl(targetForm, field);
        targetControl.setValidators(validators);
        targetControl.updateValueAndValidity();
    }

    protected clearValidators(field: string, targetForm = this.form): void {
        const targetControl = getControl(targetForm, field);
        targetControl.clearValidators();
        targetControl.updateValueAndValidity();
    }
}
